export default __webpack_public_path__ + "static/media/element_95.dfd3186c.webp";